Ext.define('SA.data.Datasets', {
    singleton: true,

    getName(dataset) {
        if (SA.data.UserDatasets.isUserDataset(dataset)) {
            return SA.data.UserDatasets.getName(dataset);
        }

        return SA.data.Vendors.getDatasetModel(dataset).getName();
    },

    isHierarchical(dataset) {
        return ['USACS', 'USACSSUB', 'USCEX', 'USDEC2000', 'USDEC2010'].includes(dataset);
    }
});